<template>
	<div class="mb-5 no-select" v-cloak>
		<div class="row row-header" v-show="false">
			<div class="col-lg-2"></div>
			<div class="col-lg-8 align-self-center text-center">
				<h1>Free Social Media Bundles</h1>
			</div>
			<div class="col-lg-2"></div>
		</div>

		<div class="row row-main">
			<div class="col-12" v-if="overviewLoaded && isLoggedIn">
				<div class="header-simple text-center">
					<h1>Claim Your Free Canva Bundles</h1>
					<p>Claim as many free bundles as you like.</p>
				</div>
			</div>

			<div class="col-12" v-else-if="overviewLoaded">
				<div class="hero-logged-out">
					<div class="hero-copy">
						<h1>{{ heroHeadline }}</h1>
						<p class="hero-body">Start with free Canva templates today, plus get {{ formattedVoucherDiscountPct }}% off your first premium bundle.</p>
						<p class="hero-note">No payment required to claim freebies.</p>
					</div>
					<div class="hero-actions">
						<a class="hero-button hero-button-primary" :href="registerRedirectUrl">Create Free Account</a>
						<a class="hero-button hero-button-secondary" :href="loginRedirectUrl">Log In</a>
					</div>
				</div>
			</div>

			<!-- categories -->
			<div class="col-12 text-center">
				<div class="category-button no-select" :class="classSelected(category.categoryID)" v-for="(category, i) in freebieCategories" :key="category.categoryID" @click="selectCategory(category.categoryID)">
					{{category.categoryName}}&nbsp;({{category.nrFreebies}})
				</div>
			</div>
			<!-- categories -->

			<!-- freebie bundles -->
			<div class="col-12">
				<div class="row row-fr-bundles justify-content-center">
					<div class="col-sm-12 col-md-6 col-lg-4 col-fr-bundle" v-for="(oBundle, i) in bundles" :key="oBundle.ID">
						<div class="container-fr-bundle">
							<div class="fr-bundle-header flex-center">
								<p class="bold">{{oBundle.name}}</p>
							</div>
							<a :href="getProperBundleUrl(oBundle)">
								<img class="fr-bundle-image" :src="getPreviewImage(oBundle)" />
							</a>
							<div class="flex-center fr-bundle-cta">
								<p v-show="isOwned(oBundle)"><a :href="getOwnedBundleUrl(oBundle)" target="_blank" title="You own this bundle. Click here to view it.">View In 'My Bundles'</a></p>
								<p class="bold" v-show="isUnowned(oBundle)"><a class="always-underline" :href="getUnownedBundleUrl(oBundle)" target="_blank" title="You don't own this bundle yet. Click here to get it!">Claim This Free Bundle!</a></p>
							</div>
							<div class="ribbon-wrap a-right" v-show="isOwned(oBundle)">
								<div class="ribbon-content"><span>Owned!</span></div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- freebie bundles -->

			<!-- paginator -->
			<div class="col-12 d-flex justify-content-center mt-2">
				<paginator v-model="pageOptions.pageIndex" v-bind="pageOptions" @paginate="getSelectedPage" :disabled="requestActive" ></paginator>
			</div>
			<!-- paginator -->
		</div>
	</div>
</template>




<script>
	import { mixinAxios } from '@/js/shared/VueMixins.js';
	import paginator from './common/Paginator.vue';

	export default {
		mixins: [mixinAxios],
		components: {
			paginator
		},
		data: () => ({
			pageOptions: {
				options: {
					texts: {
						countMultiPage: 'Showing {from} to {to} of {count} free bundles.',
						countSinglePage: '{count} Free bundles.',
						countSingleItem: '1 Free bundle.'
					}
				},
				nrRecords : 0,
				pageSize : 6,
				pageIndex : 0,
				pageSetSize: 10,
				disabled : false
			},
			availableFreebieCategories: {},
			ownedBundleIDs: {},
			overviewLoaded: false,
			veriVoucherDiscountPct: 0,
			visitorStatus: {},
			wListedBundleIDs: {},
			selectedCategoryID: 0,
			bundles: []
		}),
		mounted() {
			this.initData();
		},
		methods: {
			initData() {
				this.mixinAxios().get('/api/guest/GetFreebieBundlesOverviewInfo')
					.then((freebiesOverviewInfo) => {
						this.availableFreebieCategories = freebiesOverviewInfo.data.availableFreebieCategories;
						this.ownedBundleIDs             = freebiesOverviewInfo.data.ownedBundleIDs;
						this.veriVoucherDiscountPct     = freebiesOverviewInfo.data.veriVoucherDiscountPct;
						this.visitorStatus              = freebiesOverviewInfo.data.visitorStatus;
						this.wListedBundleIDs           = freebiesOverviewInfo.data.wListedBundleIDs;
						this.overviewLoaded             = true;

						this.getFreebieBundlesPaginated();
					});
			},
			getFreebieBundlesPaginated() {
				var params = {
					params: {
						idCategory       : this.selectedCategoryID,
						pageIndex        : this.pageOptions.pageIndex,
						pageSize         : this.pageOptions.pageSize
					}
				};

				this.mixinAxios().get('/api/guest/GetFreebieBundlesPaginated', params)
					.then((paginatedBundles) => {
						this.pageOptions.nrRecords = paginatedBundles.data.nrRecords;
						this.bundles  = paginatedBundles.data.entities;
					});
			},
			getSelectedPage(pageIndex) {
				this.getFreebieBundlesPaginated();
			},
			selectCategory(idCategory) {
				this.selectedCategoryID = idCategory;
				this.pageOptions.pageIndex = 0;

				this.getFreebieBundlesPaginated();
			},
			getPreviewImage(oBundle) {
				return (oBundle?.images?.[0]?.img500Url);
			},
			isOwned(oBundle) {
				return (this.ownedBundleIDs?.[oBundle.id] != null);
			},
			isUnowned(oBundle) {
				return (!this.isOwned(oBundle));
			},
			getOwnedBundleUrl(oBundle) {
				return `/my-bundles/${oBundle.id}/`;
			},
			getUnownedBundleUrl(oBundle) {
				return (oBundle?.url ?? '');
			},
			getProperBundleUrl(oBundle) {
				return (this.isOwned(oBundle))
					? this.getOwnedBundleUrl(oBundle)
					: this.getUnownedBundleUrl(oBundle);
			},
			classSelected(idCategory) {
				return {
					'selected': (idCategory == this.selectedCategoryID)
				};
			}
		},
		computed: {
			freebieCategories() {
				// get values from dictionary sorted by name
				var otherCats = Object.values(this.availableFreebieCategories)
					.sort((a, b) => (a.categoryName < b.categoryName) ? -1 : 1);

				// create 'all' category
				var firstCat = [{
					nrFreebies: otherCats.reduce((acc, x) => acc + x.nrFreebies, 0),
					categoryID: 0,
					categoryName: 'All'
				}];

				// return merged
				return firstCat.concat(otherCats);
			},
			formattedVoucherDiscountPct() {
				return Number(this.veriVoucherDiscountPct || 0).toString();
			},
			heroHeadline() {
				return (this.totalNrFreebies === 1)
					? 'Create a free account to claim 1 free Canva bundle'
					: `Create a free account to claim ${this.totalNrFreebies} free Canva bundles`;
			},
			isLoggedIn() {
				return (this.visitorStatus?.isLoggedIn === true);
			},
			loginRedirectUrl() {
				return `${location.origin}/login/?redirect=${encodeURIComponent(location.href)}`;
			},
			registerRedirectUrl() {
				return `${location.origin}/register/?redirect=${encodeURIComponent(location.href)}`;
			},
			totalNrFreebies() {
				return Object.values(this.availableFreebieCategories)
					.reduce((acc, x) => acc + (x?.nrFreebies ?? 0), 0);
			},
			disablePaginator() {
				return this.requestActive;
			}
		}
	}
</script>




<style scoped>
	[v-cloak] {
		display: none;
	}

	.row-header {
		background-image: url(/img/bundles/bg-template.png);
		height: 500px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		margin: 0;
	}

	div.row-main {
		max-width: 1200px;
		margin: 0 auto auto auto;
	}

	.header-simple {
		padding: 2.5rem 1.5rem 1rem 1.5rem;
	}

	.header-simple h1 {
		color: #0f2855;
		font-size: clamp(2rem, 4vw, 3.1rem);
		font-weight: 800;
		line-height: 1.05;
		margin: 0;
	}

	.header-simple p {
		color: #334155;
		font-size: 1.05rem;
		margin: 0.9rem auto 0 auto;
		max-width: 650px;
	}

	.hero-logged-out {
		background:
			linear-gradient(135deg, rgba(224, 231, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 52%, rgba(245, 248, 255, 1) 100%);
		border: 1px solid rgba(129, 140, 248, 0.24);
		border-radius: 28px;
		box-shadow: 0 18px 44px rgba(79, 70, 229, 0.12);
		margin: 2rem 0 1.35rem 0;
		overflow: hidden;
		padding: 1.9rem 2.15rem 1.75rem 2.15rem;
		position: relative;
	}

	.hero-logged-out::before {
		background: radial-gradient(circle at top right, rgba(56, 189, 248, 0.2), transparent 55%);
		content: '';
		height: 260px;
		position: absolute;
		right: -50px;
		top: -90px;
		width: 260px;
	}

	.hero-copy {
		max-width: 980px;
		position: relative;
		z-index: 1;
	}

	.hero-copy h1 {
		color: #0f2855;
		font-size: clamp(2.2rem, 5vw, 3.5rem);
		font-weight: 800;
		line-height: 1.02;
		margin: 0;
	}

	.hero-body {
		color: #334155;
		font-size: 1.08rem;
		line-height: 1.65;
		margin: 0.95rem 0 0 0;
		max-width: 780px;
	}

	.hero-note {
		color: #4338ca;
		font-size: 0.98rem;
		font-weight: 700;
		margin: 0.8rem 0 0 0;
	}

	.hero-actions {
		align-items: center;
		display: flex;
		flex-wrap: wrap;
		gap: 0.9rem;
		margin-top: 1.4rem;
		position: relative;
		z-index: 1;
	}

	.hero-button {
		border-radius: 999px;
		display: inline-flex;
		font-size: 1rem;
		font-weight: 800;
		justify-content: center;
		min-width: 190px;
		padding: 0.95rem 1.45rem;
		text-decoration: none;
		transition: transform 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease, color 0.15s ease;
	}

	.hero-button:hover,
	.hero-button:focus {
		text-decoration: none;
		transform: translateY(-1px);
	}

	.hero-button-primary {
		background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%);
		box-shadow: 0 14px 28px rgba(79, 70, 229, 0.24);
		color: #ffffff;
	}

	.hero-button-primary:hover,
	.hero-button-primary:focus {
		color: #ffffff;
	}

	.hero-button-secondary {
		background: rgba(255, 255, 255, 0.92);
		border: 1px solid rgba(67, 56, 202, 0.22);
		box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
		color: #0f2855;
	}

	.hero-button-secondary:hover,
	.hero-button-secondary:focus {
		color: #0f2855;
	}

	div.category-button {
		border: 1px solid #dddddd;
		border-radius: 5px;
		padding: 5px 10px;
		display: inline-block;
		margin: 5px;
		cursor: pointer;
		background: #ffffff;
	}

	.category-button.selected {
		background: rgb(224, 231, 255);
	}

	.row-fr-bundles {
		padding: 0px 15px 15px 0px;
	}

	.col-fr-bundle {
		border: 0px solid black;
		padding: 0px;
	}

	.container-fr-bundle {
		border-radius: 15px;
		border: 1px solid #cccccc;
		margin: 15px 0px 0px 15px;
		position: relative;
	}

	.fr-bundle-header {
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		background: rgb(67, 56, 202);
		color: white;
		padding: 0px 12px;
	}

	.fr-bundle-header p {
		width: 100%;
		text-align: center;
	}

	.col-fr-bundle img {
		width: 100%;
	}

	.col-fr-bundle p {
		margin: 8px 0px;
	}

	.flex-center {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.bold {
		font-weight: bold;
	}

	a.always-underline {
		text-decoration: underline;
	}

		a.always-underline:hover {
			text-decoration: underline;
		}

		a.always-underline:focus {
			text-decoration: underline;
		}

		a.always-underline:active {
			text-decoration: underline;
		}




	/* RIBBON */

	.ribbon-wrap {
		position: absolute;
		right: -36px;
		top: 17px;
		width: 130px;
		-ms-transform: rotate(-45deg);
		-webkit-transform: rotate(-45deg);
		transform: rotate(-45deg);
		border-left: 25px solid transparent;
		border-right: 25px solid transparent;
		border-bottom: 25px solid rgb(224, 231, 255);
		box-shadow: 0px 6px 5px -5px rgba(0, 0, 0, 0.5);
		z-index: 999;
	}

		.ribbon-wrap.a-right {
			-ms-transform: rotate(45deg);
			-webkit-transform: rotate(45deg);
			transform: rotate(45deg);
		}

		.ribbon-wrap .ribbon-content {
			position: absolute;
			left: 17px;
			top: 3px;
			font-size: 15px;
			font-weight: bold;
			line-height: 19px;
			color: #000;
			width: auto;
			text-align: center;
			word-spacing: -1px;
		}

	/* RIBBON */




	/* MEDIA QUERIES */

	/* value hardcoded to centered text in header */
	@media screen and (max-width: 648px) {
		div.row-main {
			margin: -175px auto auto auto;
		}
	}

	/* value hardcoded to centered text in header */
	@media screen and (max-width: 372px) {
		div.row-main {
			margin: -150px auto auto auto;
		}
	}

	@media screen and (max-width: 767px) {
		.hero-logged-out {
			padding: 1.45rem 1.15rem 1.35rem 1.15rem;
		}

		.hero-actions {
			width: 100%;
		}

		.hero-button {
			width: 100%;
		}
	}

	/* MEDIA QUERIES */

</style>
